// 接続設定 Dialog (= DDSIM-21、 ADR-0026 §E)。
// MULTI 対戦の wiring は Phase 2。 ONLINE menu 項目から呼び出す。

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { getHealthz } from "@/lib/api";
import { useAppStore } from "@/store";

const LOCALHOST_URL = "http://localhost:7878";

interface ConnectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ConnectDialog({
  open,
  onOpenChange,
}: ConnectDialogProps): JSX.Element {
  const navigate = useNavigate();
  const serverBaseUrl = useAppStore((s) => s.serverBaseUrl);
  const lastError = useAppStore((s) => s.lastError);
  const setBaseUrl = useAppStore((s) => s.setBaseUrl);
  const setError = useAppStore((s) => s.setError);
  const [busy, setBusy] = useState<boolean>(false);

  async function handleConnect(): Promise<void> {
    setBusy(true);
    setError(null);
    try {
      await getHealthz(serverBaseUrl);
      onOpenChange(false);
      navigate("/practice");
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>ONLINE — サーバー接続</DialogTitle>
          <DialogDescription>
            ホスト URL を入力して接続してください。
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Input
            type="url"
            value={serverBaseUrl}
            onChange={(e) => setBaseUrl(e.target.value)}
            placeholder="http://localhost:7878"
            disabled={busy}
          />
          <div className="flex gap-2">
            <Button
              variant="outline"
              onClick={() => setBaseUrl(LOCALHOST_URL)}
              disabled={busy}
            >
              localhost ({LOCALHOST_URL})
            </Button>
            <Button variant="outline" disabled>
              公式ホスト
            </Button>
          </div>
          <Button onClick={handleConnect} disabled={busy} className="w-full">
            {busy ? "接続中..." : "接続"}
          </Button>
          {lastError !== null && (
            <p className="text-sm text-destructive">{lastError}</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
